class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    // I have edited this so that the ajax add to cart works with custom for inputs and fields
    var serializedForm = JSON.parse(serializeForm(this.form));
    var propertiesMap = {};

    for(var key of Object.keys(serializedForm)) {
      if(key.startsWith("properties[")) {
        const start = key.indexOf('[') + 1;
        const end = key.lastIndexOf(']');
        var actualKey = key.substring(start, end);
        propertiesMap[actualKey] = serializedForm[key];
      }
    }

    var self = this;

    jQuery.ajax({
      type: "POST",
      dataType: "JSON",
      url: "/cart/add.js",
      data: {
        items: [
          {
            quantity: 1,
            id: serializedForm.id,
            properties: propertiesMap
          }
        ],
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      }
    }).done(function(response) {

      self.cartNotification.renderContents(response);

      try {
        // Send add to cart event to Klaviyo, so we can trigger a new flow
        _learnq.push(['track', 'Added to Cart', response.items[0]]);
      } catch(err) {

      }

    }).fail(function(e) {
      console.error("EL NOTE: if it fails here, you might be trying to use the site on URL e.g. http://127.0.0.1:9292/products/the-jeanie-leather-clutch-in-metallic-silver, but you should use the preview URL instead i.e.  https://elizabeth-eden.myshopify.com/products/the-jeanie-leather-clutch-in-metallic-silver?preview_theme_id=125665476785 This is because the sections templates do not come back on the request... no idea why! But they do when you use normal preview URL");
      console.error(e); // EL NOTE: if it fails here, you might be trying to use the site on URL e.g. http://127.0.0.1:9292/products/the-jeanie-leather-clutch-in-metallic-silver, but you should use the preview URL instead i.e.  https://elizabeth-eden.myshopify.com/products/the-jeanie-leather-clutch-in-metallic-silver?preview_theme_id=125665476785 This is because the sections templates do not come back on the request... no idea why! But they do when you use normal preview URL
    }).always(function() {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
    
  }
}

customElements.define('product-form', ProductForm);
